export default __webpack_public_path__ + "static/media/4.8c8a26da.mp3";